"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.SecondaryTextLine = exports.PrimaryTextLine = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.PrimaryTextLine = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
// this is the line that display refresh time and status
// (relates to property "dense", meaning if dense, display this line too)
exports.SecondaryTextLine = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-style: italic;
  font-weight: 200;
  color: ${({ theme }) => theme.palette.text.primary};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const styles = (theme) => {
    const { accountDrawer } = theme.mixins;
    const { accountListBaseFontSize: baseFontSize } = accountDrawer;
    const listItemCommonStyle = {
        paddingRight: accountDrawer.listPaddingRight,
        paddingLeft: accountDrawer.listPaddingLeft,
        '&.selected': {
            background: accountDrawer.highlightColor,
        },
    };
    const listItem = Object.assign(Object.assign(Object.assign({}, theme.typography.subtitle1), listItemCommonStyle), { fontWeight: 400, fontSize: 16, marginLeft: 0, '&.disabled': {
            cursor: 'default',
        }, '&:hover': {
            backgroundColor: accountDrawer.hoverColor,
        } });
    return ({
        root: {
            width: '100%',
            background: theme.palette.background,
        },
        collapseContainer: {
            paddingBottom: 5,
        },
        listItem,
        listItemL0: Object.assign(Object.assign(Object.assign({}, listItemCommonStyle), listItem), { textTransform: 'uppercase', height: accountDrawer.l0Height, '&.expandable': {
                fontWeight: 400,
            } }),
        listItemL1: Object.assign(Object.assign(Object.assign({}, listItemCommonStyle), listItem), { textTransform: 'uppercase', margin: accountDrawer.l1Margin, height: accountDrawer.l1Height, backgroundColor: accountDrawer.l1Color, '&.expandable': {
                fontWeight: 400,
            } }),
        listItemL2: Object.assign(Object.assign(Object.assign({}, listItemCommonStyle), listItem), { fontSize: baseFontSize * 0.90, height: accountDrawer.l2Height, textTransform: 'capitalize', '&.expandable': {
                fontWeight: 400,
            } }),
        listItemL3: Object.assign(Object.assign(Object.assign({}, listItemCommonStyle), listItem), { fontSize: baseFontSize * 0.80, height: accountDrawer.l3Height }),
        listItemText: {
            paddingRight: 0,
            margin: 0,
        },
        listItemTextL123: {
            '&.selected': {
                color: accountDrawer.highlightText,
            },
        },
        listItemTextL0: Object.assign(Object.assign({}, theme.typography.body1), { marginLeft: 0, color: accountDrawer.textColor, fontSize: `${baseFontSize}px`, fontWeight: 500, '&.selected': {
                color: accountDrawer.highlightText,
            } }),
        listItemTextL1: Object.assign(Object.assign({}, theme.typography.body1), { marginLeft: 0, color: accountDrawer.textColor, fontSize: `${baseFontSize * 0.93}px`, fontWeight: 500, '&.selected': {
                color: accountDrawer.highlightText,
            } }),
        listItemTextL2: Object.assign(Object.assign({}, theme.typography.body1), { fontSize: `${baseFontSize * 0.85}px`, fontWeight: 500, color: accountDrawer.l2TextColor, '&.selected': {
                color: accountDrawer.highlightText,
            } }),
        listItemTextL3: Object.assign(Object.assign({}, theme.typography.body2), { color: accountDrawer.l3TextColor, fontSize: `${baseFontSize * 0.85}px`, textAlign: 'left', '&.left': {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                marginRight: 16,
            }, marginLeft: accountDrawer.accountListLevelIndent, '&.selected': {
                color: accountDrawer.highlightText,
            } }),
        listItemIconButtonL0: {
            fontSize: '18px',
            padding: '1px',
            color: accountDrawer.textColor,
        },
        listItemIconButtonL1: {
            fontSize: '18px',
            padding: '1px',
            color: accountDrawer.textColor,
        },
        listItemIconButtonL2: {
            fontSize: '18px',
            padding: '1px',
            color: accountDrawer.textColor,
        },
        listItemIconButtonL3: {
            fontSize: '18px',
            padding: '1px',
            color: accountDrawer.textColor,
        },
        secondaryActionIcon: {
            opacity: 0.8,
            color: theme.palette.text.secondary,
        },
        positiveBalDark: {
            color: accountDrawer.positiveBalance,
        },
        negativeBalDark: {
            color: accountDrawer.negativeBalance,
        },
        errorIcon: {
            color: accountDrawer.errorIcon,
        },
        infoIcon: {
            color: theme.palette.status.attentionMain,
        },
        refreshingProgress: {
            fontSize: '20px',
            padding: '1px',
            color: theme.palette.text.contrastText,
        },
        sectionContainer: {
            marginBottom: 20,
        },
        accountBar: {
            width: 6,
            height: 4,
            marginRight: 4,
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        closedText: {
            width: 160,
            color: accountDrawer.textColor,
        },
    });
};
exports.styles = styles;
